import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/utils.js';
// Inline form error with role=alert so screen readers announce it. Replaces the
// scattered `<p className="text-sm text-destructive">{error}</p>` snippets.
export function FormError({ children, className }) {
    if (!children)
        return null;
    return (_jsx("p", { role: "alert", className: cn('text-sm text-destructive', className), children: children }));
}
